import { render } from "./ImmediateTaggingOverview.vue?vue&type=template&id=0c37a0a0&scoped=true"
import script from "./ImmediateTaggingOverview.vue?vue&type=script&lang=js"
export * from "./ImmediateTaggingOverview.vue?vue&type=script&lang=js"

import "./ImmediateTaggingOverview.vue?vue&type=style&index=0&id=0c37a0a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c37a0a0"]])

export default __exports__